import styled from '@emotion/styled';
import { Button } from 'antd';

import { css } from 'config/emotionCss';

import colors from 'config/theme/colors';
import {
  SIGNATURE_INFO_FONT_SIZE_PERCENTAGE,
  SIGNATURE_INFO_MIN_WIDTH_PERCENTAGE,
  SIGNATURE_INFO_TEXT_MARGIN_PERCENTAGE
} from 'ui/base/SignatureMedia/constants';

import type { ZoneData } from './hooks/useSignZoneTypes';

export const iconStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.1rem;
`;

export const SignZoneTooltip = styled('div', { target: 'fb-signature-media-sign-zone-tooltip' })`
  display: none;
  cursor: default;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  position: absolute;
  white-space: nowrap;
  background-color: white;
  box-shadow: 0 5px 10px 0 rgba(45, 45, 45, 0.20);
`;

export const modalStyle = css`
  top: 10px !important;
  
  & .ant-modal-body {
    min-height: calc(100svh - 200px) !important;
    
    display: flex;
    flex-direction: column;
    
    &>div {
      flex-grow: 1;
    }
    
    & canvas {
      width: auto !important;
      height: auto !important;
      max-width: 100% !important;
      max-height: calc(100svh - 360px) !important;
    }
    
    & .react-pdf__Page {
      &:hover ${SignZoneTooltip} {
        display: block;
      }
    }
  }
`;

export const SignContainer = styled.div<ZoneData>`
  top: ${({ top }) => top}%;
  left: ${({ left }) => left}%;
  position: absolute;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
`;

export const SignZone = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  width: 100%;
  height: 100%;
  align-items: end;
  
  border-radius: 4px;
  background-color: rgba(29, 37, 45, 0.20);
  border: 2px dashed ${colors['@text-color']};
  cursor: move;

  & > .placeholder {
    width: 100%;
    font-size: 12px;
    text-align: center;
    font-style: italic;
    text-decoration: underline;
  }

  &.small > .placeholder {
    display: none;
  }
`;

export const SignInfo = styled.div<{minPageSize: number, width: number}>`
  position: absolute;
  left: 50%;
  bottom: ${({ minPageSize }) => -(SIGNATURE_INFO_TEXT_MARGIN_PERCENTAGE * 2.5 + SIGNATURE_INFO_FONT_SIZE_PERCENTAGE * 2) * minPageSize}px;
  overflow: hidden;
  transform: translateX(-50%);
  width: ${({ width, minPageSize }) => Math.max(SIGNATURE_INFO_MIN_WIDTH_PERCENTAGE * minPageSize, width)}px;
  background-color: ${colors['@body-bg']};
  border-radius: 4px;
  
  display: flex;
  align-items: center;
  flex-direction: column;
  
  span {
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${colors['@text-color-secondary']};
    font-size: ${({ minPageSize }) => SIGNATURE_INFO_FONT_SIZE_PERCENTAGE * minPageSize}px;
    line-height: ${({ minPageSize }) => SIGNATURE_INFO_FONT_SIZE_PERCENTAGE * minPageSize}px;
    padding: ${({ minPageSize }) => SIGNATURE_INFO_TEXT_MARGIN_PERCENTAGE * minPageSize / 2}px 3px;
  }
`;

export const ResizeIcon = styled.div`
  cursor: nwse-resize;
  
  display: flex;
  align-items: end;
  justify-content: end;
  
  width: 24px;
  height: 24px;

  
  &::before {
    content: ' ';
    width: 30px;
    height: 30px;
    position: absolute;
  }
  
  &>i {
    padding: 0 3px 3px 0;
    font-size: 8px;
  }
`;

export const DeleteButton = styled(Button)`
  margin: 3px 3px 0 0;
  z-index: 100;
  min-height: 24px;
`;

export const tagPillStyle = css`
  padding: 4px 12px !important;
  min-width: fit-content !important;
`;
